import { i18n } from '../../../lang/i18n';
import { NavLink } from 'react-router-dom';

export default function UserLoginLinkError() {
    return (<div className="users">
        <div className="main-subtitle">
            <h3>{i18n.CustomerLoginLinkError.Title}</h3>
        </div>
        <div className="card-body">
            <div className="container">
                <div className="row">
                    <div className="col text-center">
                        <p>{i18n.CustomerLoginLinkError.Message}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="container main-subtitle mt-1">
                            <NavLink to="/" className="btn-back link-btn"> <i className="fa fa-home" /> {i18n._BTNs.GoHome}</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}